export const INVOICE_PAYMENT_STATUSES = [
  {
    id: 'in-progress',
    value: 'in-progress',
    label: 'In progress',
    selected: true,
  },
  {
    id: 'in-anomaly',
    value: 'in-anomaly',
    label: 'In anomaly',
    selected: true,
  },
  {
    id: 'paid',
    value: 'paid',
    label: 'Paid',
    selected: true,
  },
  {
    id: 'rejected',
    value: 'rejected',
    label: 'Rejected',
    selected: true,
  },
  {
    id: 'cashed',
    value: 'cashed',
    label: 'Cashed',
    selected: true,
  },
  {
    id: 'abandoned',
    value: 'abandoned',
    label: 'Abandoned',
    selected: true,
  },
];

export const INVOICE_STATUSES = ['draft', 'manually-rejected', 'abandoned'];

export const COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customerFirstNameLastName',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-120 pointer',
    selected: true,
  },
  {
    label: 'Number',
    accessor: 'invoiceNumber',
    type: 'text',
    isFilterable: false,
    selected: true,
  },
  {
    label: 'Date',
    accessor: 'createdAt',
    type: 'invoiceDate',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Date: Later first',
  },
  {
    label: 'Total',
    accessor: 'total_amount',
    type: 'amount',
    isFilterable: false,
    isSortable: false,
  },
  {
    label: 'AMO',
    accessor: 'amo_part_amount',
    type: 'amount',
    isFilterable: false,
    isSortable: false,
  },
  {
    label: 'AMC',
    accessor: 'amc_part_amount',
    type: 'amount',
    isFilterable: false,
    isSortable: false,
  },
  {
    label: 'RAC',
    accessor: 'patient_part_amount',
    type: 'amount',
    isFilterable: false,
    isSortable: false,
    tooltip: 'Reste à charge',
  },
  {
    label: 'Payment status',
    accessor: 'invoicePaymentStatus',
    type: 'invoicePaymentStatus',
    isFilterable: true,
    isSortable: false,
    selected: false,
    options: INVOICE_PAYMENT_STATUSES,
  },
  {
    label: 'Links',
    accessor: 'invoice',
    type: 'linkAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-actions',
  },
];
